import { Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';
import { Visitor } from 'src/app/models/visitor';

@Component({
  selector: 'app-visitor-categories',
  templateUrl: './visitor-categories.component.html',
  styleUrls: ['./visitor-categories.component.scss'],
})
export class VisitorCategoriesComponent {
  @Input() set chartData(val: any) {
    this.setChartData(val);
  }
  @Input() set chartHeight(val: any) {
    if (val) this.height = val + 'px';
  }
  height = '';
  option: EChartsOption;
  visitorList: Visitor[] = [];
  colorPalette = ['#003f5c', '#58508d', '#bc5090', '#ff6361', '#ffa600'];

  constructor() {}
  private setChartData(data: any) {
    this.option = {
      tooltip: {
        trigger: 'item',
      },
      legend: {
        bottom: '5%',
        left: 'center',
      },
      series: [
        {
          type: 'pie',
          radius: ['25%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2,
            // color: (params) =>
            //   this.colorPalette[params.dataIndex % this.colorPalette.length],
          },
          label: {
            show: false,
            position: 'center',
          },
          emphasis: {
            label: {
              show: false,
              fontSize: 40,
              fontWeight: 'bold',
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            {
              value: data.singleVerified ? data.singleVerified : 0,
              name: 'Verified',
            },
            {
              value: data.singleUnverified ? data.singleUnverified : 0,
              name: 'Unverified ',
            },
            {
              value: data.singlePending ? data.singlePending : 0,
              name: 'Pending',
            },
            {
              value: data.singleAutoRejected ? data.singleAutoRejected : 0,
              name: 'Auto-Rejected',
            },
            {
              value: data.singleRejected ? data.singleRejected : 0,
              name: 'Rejected',
            },
          ],
        },
      ],
    };
  }
}
